import * as Actions from '../actions'
import * as Validation from '../validation'
import { LoftServices } from '../../../types/loft'

Actions.withOperationName(Actions)
Actions.withOperationName(Validation)

export default [
  Actions.startProgress,
  Actions.setMessageIds,
  Actions.setSession,
  Validation.throwOnInvalidSession,
  Actions.configureGateway,
  Actions.awaitAsync('me', ({ gateway }: LoftServices) => gateway.me.get()),
  Actions.setUserLocale,
  Actions.setTracingContext,
  Actions.awaitAsync('to', ({ office }: LoftServices) => office.item.getTo()),
  Actions.awaitAsync('subject', ({ office }: LoftServices) => office.item.getSubject()),
  Actions.awaitAsync('templateId', ({ office }: LoftServices) => office.item.getTemplateId()),
  Actions.awaitAsync('crmReferences', ({ office }: LoftServices) => office.item.getCrmReferences()),
  Actions.setRecipientEmail,
  Validation.throwOnInvalidRecipient,
  Actions.awaitRecipient,
  Validation.throwOnInvalidPerson,
  Actions.chooseStrategy,
  Actions.updateProgress('preparing_message'),
]
